var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    { on: { submit: _vm.onSubmit } },
    [
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-lastname",
            label: "Nom",
            "label-for": "input-lastname",
          },
        },
        [
          _c("b-form-input", {
            attrs: { id: "input-lastname", type: "text", required: "" },
            model: {
              value: _vm.form.staf_lastname,
              callback: function ($$v) {
                _vm.$set(_vm.form, "staf_lastname", $$v)
              },
              expression: "form.staf_lastname",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-firstname",
            label: "Prénom",
            "label-for": "input-firstname",
          },
        },
        [
          _c("b-form-input", {
            attrs: { id: "input-firstname", type: "text", required: "" },
            model: {
              value: _vm.form.staf_firstname,
              callback: function ($$v) {
                _vm.$set(_vm.form, "staf_firstname", $$v)
              },
              expression: "form.staf_firstname",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-email",
            label: "E-mail",
            "label-for": "input-email",
          },
        },
        [
          _c("b-form-input", {
            attrs: { id: "input-email", type: "email" },
            model: {
              value: _vm.form.staf_email,
              callback: function ($$v) {
                _vm.$set(_vm.form, "staf_email", $$v)
              },
              expression: "form.staf_email",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-gender",
            label: "Genre",
            "label-for": "input-gender",
          },
        },
        [
          _c("b-form-select", {
            attrs: { id: "input-gender", options: _vm.genders },
            model: {
              value: _vm.form.staf_is_male,
              callback: function ($$v) {
                _vm.$set(_vm.form, "staf_is_male", $$v)
              },
              expression: "form.staf_is_male",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-job",
            label: "Rôle",
            "label-for": "input-job",
          },
        },
        [
          _c("b-form-select", {
            attrs: { id: "input-job", options: _vm.roles },
            model: {
              value: _vm.form.job_id,
              callback: function ($$v) {
                _vm.$set(_vm.form, "job_id", $$v)
              },
              expression: "form.job_id",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { id: "input-group-checks-visible" } },
        [
          _c(
            "b-form-checkbox",
            {
              attrs: { id: "checkbox-is_visible", switch: "" },
              model: {
                value: _vm.form.sest_is_visible,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "sest_is_visible", $$v)
                },
                expression: "form.sest_is_visible",
              },
            },
            [_vm._v("Affiché dans les listes sur tablette")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-checkbox",
        {
          attrs: { id: "checkbox-is_enable", switch: "" },
          model: {
            value: _vm.form.sest_is_enable,
            callback: function ($$v) {
              _vm.$set(_vm.form, "sest_is_enable", $$v)
            },
            expression: "form.sest_is_enable",
          },
        },
        [_vm._v("Actif")]
      ),
      _vm._v(" "),
      _c(
        "b-form-checkbox",
        {
          attrs: { id: "checkbox-is_delete", switch: "" },
          model: {
            value: _vm.form.sest_is_delete,
            callback: function ($$v) {
              _vm.$set(_vm.form, "sest_is_delete", $$v)
            },
            expression: "form.sest_is_delete",
          },
        },
        [_vm._v("Supprimé")]
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "float-right" },
        [
          _c(
            "b-button",
            { attrs: { type: "close" }, on: { click: _vm.onCancel } },
            [_vm._v("Annuler")]
          ),
          _vm._v(" "),
          _c("b-button", { attrs: { type: "submit", variant: "primary" } }, [
            _vm._v("Valider"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }